export default {
  title: 'Ajouter un fichier : {{slot}}',
  replace_title: 'Remplacer le fichier : {{slot}}',
  replace_description: "Le nouveau fichier remplace celui-ci. Nous conservons l'ancien dans nos archives.",
  form: {
    kind: {
      label: "Type de pièce d'identité",
      options: {
        passport: 'Passeport',
        driver_license: 'Permis de conduire',
        id_card: "Carte d'identité",
        residence_permit: 'Titre de séjour',
      },
    },
    front: {
      label: 'Recto',
    },
    back: {
      label: 'Verso',
    },
    file: {
      label: 'Fichier',
    },
    expires_at: {
      label: "Valable jusqu'au",
      placeholder: 'Sélectionner une date',
    },
    holder: {
      label: "À qui appartient cette pièce d'identité ?",
      options: {
        owner: 'La mienne, celle du propriétaire',
        partner: "Celle d'un associé",
      },
    },
    holder_name: {
      label: "Nom de l'associé",
      placeholder: 'Prénom et nom',
    },
  },
  accepted_files: "PDF, JPG ou PNG, jusqu'à {{max}} Mo.",
  accepted_images_min: 'Une photo doit faire au moins {{min}} Ko.',
  errors: {
    file_type: 'Seuls les fichiers PDF, JPG ou PNG sont acceptés.',
    file_too_large: 'Le fichier dépasse {{max}} Mo.',
    file_too_small: 'Une photo doit faire au moins {{min}} Ko.',
  },
  buttons: {
    select_file: 'Sélectionner un fichier',
    submit: 'Téléverser',
    cancel: 'Annuler',
  },
  toasts: {
    success: 'Fichier téléversé',
    error: "Le fichier n'a pas pu être téléversé.",
  },
};
